export const MARKET_COOKIE_NAME = "ng_market";
export const LANGUAGE_COOKIE_NAME = "ng_lang";
export const SUGGESTION_COOKIE_NAME = "ng_suggestion";
